import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0c4204de"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "role-dialog"
};
const _hoisted_2 = {
  class: "role-tree w100"
};
const _hoisted_3 = {
  key: 0,
  class: "tree_boxsc"
};
const _hoisted_4 = {
  class: "ops_boxs"
};
const _hoisted_5 = {
  class: "custom-tree-node"
};
const _hoisted_6 = {
  style: {
    "font-size": "15px"
  }
};
const _hoisted_7 = {
  class: "select_boxs"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElTree } from "element-plus";
import useRoleStore from "@/store/modules/role";
import { storeToRefs } from "pinia";
import { setStatusApi, descRoleApi } from "@/service/modules/role";
import { getOrganizationApi } from "@/service/modules/alllist";
export default /*#__PURE__*/_defineComponent({
  __name: 'role-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editRoleItem: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: "addSubset"
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const dep_user_list = ref([]);
    const radio_ = ref(1);
    const defaultProps = {
      children: "children",
      label: "name",
      isLeaf: "leaf"
    };
    const emit = __emit;
    const formRef = ref();
    const treeRef = ref();
    const treeRef2 = ref();
    const roleStore = useRoleStore();
    const {
      allPermissionList
    } = storeToRefs(roleStore);
    const subBtnLoading = ref(false);
    const treeCheckStrictly = ref(true);
    const form = reactive({
      id: null,
      name: "",
      per_ids: [],
      status: 1,
      dept_ids: null,
      userids: null
    });
    const rules = {
      name: [{
        required: true,
        message: "请输入角色名称",
        trigger: "blur"
      }],
      status: [{
        required: true,
        message: "请选择启用状态",
        trigger: "change"
      }],
      per_ids: [{
        required: true,
        message: "请为角色分配菜单权限",
        trigger: "change"
      }, {
        validator: perIdsValidator,
        trigger: "blur"
      }]
    };
    function perIdsValidator(rule, value, callback) {
      if (form.per_ids.length === 0) {
        callback(new Error("请为角色分配菜单权限"));
      } else {
        callback();
      }
    }
    function restForm() {
      form.id = null;
      form.name = "";
      form.per_ids = [];
      form.status = 1;
      treeRef.value.setCheckedKeys([], false);
      subBtnLoading.value = false;
      treeCheckStrictly.value = true;
    }
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning("正在保存，请稍后~~");
      restForm();
      formRef.value?.resetFields();
      emit("closeDialog");
    }
    async function submit() {
      subBtnLoading.value = true;
      if (radio_.value == 1) {
        form.dept_ids = null;
        form.userids = null;
      } else {
        if (dep_user_list.value.length > 0) {
          //遍历一下，如果有 type并且type=1  form.value["dept_ids"] = 遍历的数组所有的 id
          let arr = dep_user_list.value.filter(item => item.type == 1);
          let arr2 = dep_user_list.value.filter(item => !item.type);
          form.dept_ids = arr.map(item => item.id).toString();
          form.userids = arr2.map(item => item.userid).toString();
        }
      }
      let query = JSON.parse(JSON.stringify(form));
      query.per_ids = query.per_ids.join(",");
      try {
        let res = await setStatusApi(query);
        ElMessage.success(props.dialogType === "add" ? "添加成功" : "修改成功");
        restForm();
        formRef.value?.resetFields();
        emit("restData");
      } catch {} finally {
        subBtnLoading.value = false;
      }
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    function handleElCheck(checkedNodes, checkedKeys, halfCheckedNodes, halfCheckedKeys) {
      let keys = [];
      if (checkedKeys.checkedKeys && checkedKeys.checkedKeys.length > 0) {
        keys = keys.concat(checkedKeys.checkedKeys);
      }
      if (checkedKeys.halfCheckedKeys && checkedKeys.halfCheckedKeys.length > 0) {
        keys = keys.concat(checkedKeys.halfCheckedKeys);
      }
      form.per_ids = keys;
    }
    const title = computed(() => {
      if (props.dialogType === "add") {
        return "添加账号";
      } else if (props.dialogType === "edit") {
        return "编辑账号";
      }
    });
    watch(() => props.dialogVisible, newValue => {
      if (newValue) {
        nextTick(async () => {
          if (props.dialogType === "edit") {
            for (let key in form) {
              if (key === "per_ids") {
                form[key] = props.itemData[key] ? props.itemData[key].split(",") : [];
              } else if (key === "dept_ids") {
                form[key] = props.itemData[key] ? props.itemData[key].split(",") : [];
              } else if (key === "userids") {
                form[key] = props.itemData[key] ? props.itemData[key].split(",") : [];
              } else {
                form[key] = props.itemData[key];
              }
            }
            if (form.dept_ids.length > 0 || form.userids.length > 0) {
              radio_.value = 2;
            } else {
              radio_.value = 1;
            }
            treeRef.value.setCheckedKeys(form.per_ids, false);
            if (radio_.value = 2) {
              let res = await descRoleApi(form.id);
              let new_data = await res.data;
              let new_dep_list = await [];
              // 合并new_data.dept_list和合并new_data.user_list,放在一个数组new_dep_list
              new_dep_list = await [...new_data.dept_list, ...new_data.user_list];
              dep_user_list.value = await new_dep_list;
              let dep_ld = [];
              //遍历出dep_user_list所有的 id 到dep_ld
              dep_ld = await dep_user_list.value.filter(item => item.type == 1).map(item => item.id);
              treeRef2.value.setCheckedKeys(dep_ld, false);
            }
          } else {
            radio_.value = 1;
            form.userids = null;
            form.dept_ids = null;
            form.per_ids = [];
            dep_user_list.value = [];
          }
          setTimeout(() => {
            treeCheckStrictly.value = false;
          });
        });
      }
    });
    const data_list = ref([]);
    const get_list = async id => {
      try {
        const res = await getOrganizationApi(id);
        if (res.code == 0) {
          // data_list.value = res.data.list;
          const updatedList = res.data.list.map(item => ({
            ...item,
            leaf: item?.children?.length ? false : true
          }));
          const updatedArray = res.data.user_list.map(item => ({
            ...item,
            leaf: item?.children?.length ? false : true
          }));
          data_list.value = [...res.data.list, ...updatedArray];
        }
      } catch (err) {} finally {}
    };
    const loadNodeData = async (node, resolve, reject) => {
      // 检查节点是否已经加载过，避免重复请求
      if (node.children && node.children.length > 0) {
        resolve(node.children); // 如果节点已有子节点，直接返回
        return;
      }
      let id = node?.data?.id || 0;
      try {
        await get_list(id); // 使用节点的 id 获取数据
        resolve(data_list.value); // 确保在数据加载完成后返回数据
      } catch (error) {
        reject(); // 如果发生错误，调用 reject
      } finally {}
    };
    const onNodeClick = data => {};
    const onRightClick = node => {};
    const getCheckedNodes = (leafOnly, includeHalfChecked, eops) => {
      // console.log(leafOnly, includeHalfChecked, "---", eops);
    };
    const getCheckedKeys = (data, node) => {
      dep_user_list.value = node.checkedNodes;
    };
    const clese = (item, index) => {
      // 从 dep_user_list 中删除
      dep_user_list.value.splice(index, 1);
      uncheckNodeInTree(data_list.value, item.id);
    };
    // 取消选中状态
    const uncheckNodeInTree = (nodes, id) => {
      for (let node of nodes) {
        if (node.id === id) {
          treeRef2.value?.setChecked(node, false, true); // 取消选中状态
          return true;
        }
        if (node.children) {
          const found = uncheckNodeInTree(node.children, id);
          if (found) {
            return true;
          }
        }
      }
      return false;
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "60%",
        top: "2vh",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[4] || (_cache[4] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "角色名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              placeholder: "请输入角色名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否启用",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.status,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.status = $event),
              "active-value": 1,
              "inactive-value": 0
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "菜单权限",
            prop: "per_ids"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElTree), {
              "check-strictly": treeCheckStrictly.value,
              class: "w100",
              ref_key: "treeRef",
              ref: treeRef,
              onCheck: handleElCheck,
              data: _unref(allPermissionList),
              "show-checkbox": "",
              "default-expand-all": "",
              "node-key": "id",
              "highlight-current": "",
              props: {
                children: 'children',
                label: 'title'
              }
            }, null, 8, ["check-strictly", "data"])])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "数据权限",
            prop: ""
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_radio_group, {
              modelValue: radio_.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => radio_.value = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("可见全部数据")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => [_createTextVNode("自定义可见")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"]), radio_.value == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_unref(ElTree), {
              "node-key": "id",
              props: defaultProps,
              ref_key: "treeRef2",
              ref: treeRef2,
              onNodeClick: onNodeClick,
              onNodeContextmenu: onRightClick,
              load: loadNodeData,
              "show-checkbox": "",
              onCheckChange: getCheckedNodes,
              onCheck: getCheckedKeys,
              lazy: ""
            }, {
              default: _withCtx(({
                node
              }) => [_createElementVNode("span", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(node.label), 1)])]),
              _: 1
            }, 512)]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dep_user_list.value, (item, index) => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: index,
                closable: "",
                type: "primary",
                class: "tag_item",
                onClose: $event => clese(item, index)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                _: 2
              }, 1032, ["onClose"]);
            }), 128))])])) : _createCommentVNode("", true)])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});